export default __webpack_public_path__ + "static/media/i.c3c8ace1.png";